<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul v-if="client">
            <li><a @click="$router.push('/chats', $router.go())">Conversaciones</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{clientName}}</a></li>
          </ul>
          <ul v-else>
            <li class="is-active"><a href="#" aria-current="page">Conversaciones</a></li>
          </ul>
        </nav>
        <div class="field">
          <label class="label">Plataforma</label>
          <div class="control">
            <div class="select">
              <select v-model="platformSelected" @change="getChats">
                <option v-for="platform in platforms" :key="platform.value" :value="platform.value">
                  {{platform.name}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="button is-primary is-left" @click="getChats">
          <span class="icon"><i class="fas fa-sync-alt"></i></span>
          <span class="is-capitalized">Actualizar</span>
        </div>
        <br><br>

        <!-- input  -->
        <div class="control is-expanded">
          <input class="input" type="text" placeholder="Filtrar por Nombre (Esc para cancelar)"
                 v-model="textFilter"
                 v-on:keyup.esc="textFilter=null">
        </div>

        <br><br>
        <div class="container" style="overflow: scroll">
        <table class="table is-striped is-fullwidth">

          <thead>
          <tr>
            <th class="is-capitalized">Plataforma</th>
            <th class="is-capitalized">Ult. Mensaje</th>
            <th class="is-capitalized">Chatbot</th>
            <th class="is-capitalized">Nombre</th>
            <th class="is-capitalized">Teléfono</th>
            <th class="table-button-column"></th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="chat in filteredChats" :key="chat.idUser">
            <td>{{chat.platform}}</td>
            <td>{{chat.lastMessage}}</td>
            <td>{{chat.client}}</td>
            <td>{{chat.name}}</td>
            <td>{{chat.phone}}</td>
            <td>
              <div class="button is-primary" @click="showChat(chat)">
                <span class="icon"><i class="fas fa-eye"></i></span>
              </div>
            </td>
          </tr>
          </tbody>

        </table>
        </div>

        <br>

        <nav v-if="!textFilter" class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="previousPage" :disabled="paginator.current === 0">Anterior</a>
          <a class="pagination-next" @click="nextPage" :disabled="paginator.current >= paginator.total">Siguiente</a>
          <ul class="pagination-list">
            <li v-for="page in paginator.total+1" :key="page">
              <a :class="page-1 === paginator.current ? 'pagination-link is-current' : 'pagination-link'"
                 @click="goPage(page-1)">
                {{page}}
              </a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      textFilter: null,
      platformSelected: 0,
      platforms: {},
      chats: [],
      paginatedChats: [],
      page: 0,
      paginator: {
        current: 0,
        total: 0,
        limit: 100
      }
    }
  },
  created () {
    this.getPlatforms()
    this.breadcrumbDetails()
  },
  computed: {
    filteredChats () {
      let self = this

      if (!self.textFilter) {
        return this.paginatedChats
      }

      return this.chats.filter(function (chat) {
        if ((chat.name.search(self.textFilter) > -1) || (chat.name.toLowerCase().search(self.textFilter) > -1)) {
          return true
        }
      })
    }
  },
  methods: {
    breadcrumbDetails () {
      if (this.client) {
        this.api.post('/ClientById/', {idClient: this.client}).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    getPlatforms () {
      this.api.post('/DataPlatformList', {idClient: this.client}).then(response => {
        this.platforms = response.platforms
        this.platformSelected = response.platforms[0].value
        this.getChats()
      })
    },
    getChats () {
      this.api.post('/UserGetList', {platform: this.platformSelected, idClient: this.client}).then(response => {
        this.chats = response.users
        this.paginator.current = 0
        this.paginate()
      })
    },
    showChat (chat) {
      this.$router.push('/chats/' + chat.idUser)
    },
    paginate () {
      this.paginator.total = Math.floor(this.chats.length / this.paginator.limit)
      this.paginatedChats = this.chats.slice(
        this.paginator.current * this.paginator.limit,
        (this.paginator.current + 1) * this.paginator.limit)
    },
    nextPage () {
      if (this.paginator.current < this.paginator.total) {
        this.paginator.current++
        this.paginate()
        window.scrollTo(0, 0)
      }
    },
    previousPage () {
      if (this.paginator.current > 0) {
        this.paginator.current--
        this.paginate()
        window.scrollTo(0, 0)
      }
    },
    goPage (page) {
      this.paginator.current = page
      this.paginate()
      window.scrollTo(0, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/Chats.vue